var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      style: { zIndex: _vm.options.zIndex },
      attrs: { "max-width": _vm.options.width, persistent: "" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          ) {
            return null
          }
          return _vm.cancel($event)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "pb-3", attrs: { color: _vm.options.color } },
        [
          _c("v-card-title", { staticClass: "justify-center" }, [
            _vm.options.asHtml
              ? _c("span", { domProps: { innerHTML: _vm._s(_vm.title) } })
              : _c("span", [_vm._v(" " + _vm._s(_vm.title) + " ")]),
          ]),
          _c(
            "v-card-text",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !!_vm.message,
                  expression: "!!message",
                },
              ],
              staticClass: "text-center",
            },
            [
              _vm.options.asHtml
                ? _c("span", { domProps: { innerHTML: _vm._s(_vm.message) } })
                : _c("span", [_vm._v(" " + _vm._s(_vm.message) + " ")]),
            ]
          ),
          _c(
            "v-card-actions",
            {
              staticClass: "pt-0 text-center",
              staticStyle: { display: "block" },
            },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "secondary", rounded: "", depressed: "" },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.agree($event)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t(_vm.options.actionButtonI18nKey)))]
              ),
              !_vm.options.disableCancel
                ? _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "background",
                        rounded: "",
                        depressed: "",
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.cancel($event)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t(_vm.options.cancelButtonI18nKey)))]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }